InlineVariations = window.InlineVariations ?= {}
InlineVariations.Collections ?= {}
InlineVariations.Models ?= {}
InlineVariations.Models.Option = require '../models/option'

InlineVariations.Collections.Options = Backbone.Collection.extend
  model: InlineVariations.Models.Option

module.exports = InlineVariations.Collections.Options
